<template>
  <BgImageLayout>
    <FormLicensePeriod :showing="showModal" context="license-index" @close="showModal = false" />

    <Grid gtr="auto 1fr" class="full-height shadow3 list-view-products relative-position">
      <Grid
        gaf="column"
        justify-content="space-between"
        align-items="center"
        class="opaque-header q-pl-xl q-pr-lg q-py-sm"
      >
        <div class="text-subtitle-2 text-secondary-2">
          License list view
          <HelpPageBtn :page="__guide.license" />
        </div>

        <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
          <ExportBtn :loading="exportLoading" @click="exportToExcel" />

          <RBtn size="small" type="tertiary" @click="showModal = true">
            create new license
          </RBtn>

          <ShowHideCols :ag-grid="agGrid" />
        </Grid>
      </Grid>

      <Grid class="q-pl-md q-pr-lg q-py-lg">
        <AgGrid
          v-if="createData"
          ref="agGrid"
          :header-height="48"
          :options="gridOptions"
          :api-request="infiniteScrollRequest"
          class="q-px-sm"
          style="grid-template-rows: 1fr"
          @ready="onGridReady"
          @export-loading="exportLoading = $event"
        />
      </Grid>
    </Grid>
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import { exportToExcel } from '@/mixins/export-to-excel'
import gridOptions from './gridOptions'
// Libraries
import { mapState } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import FormLicensePeriod from '@components/forms/form-license-period/FormLicensePeriod'
import ExportBtn from '@/reusable/ExportBtn'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'

export default {
  components: {
    AgGrid,
    FormLicensePeriod,
    ExportBtn,
    ShowHideCols,
    HelpPageBtn
  },

  mixins: [exportToExcel, gridOptions],

  data() {
    return {
      agGrid: null,
      showModal: false,
      createData: null,
      exportLoading: false,
      tableState: {
        filter: null,
        columns: null
      }
    }
  },

  created() {
    this.getAndSetCreateDataAndTableState()
  },

  beforeDestroy() {
    this.saveTableState()
  },

  methods: {
    getAndSetCreateDataAndTableState() {
      Promise.all([apiTo.GET_LICENSE_PERIODS_CREATE(), apiTo.GET_LIST_VIEW_TABLE_STATE('licenses')]).then(
        ([{ data: createData }, { data: tableState }]) => {
          this.tableState.columns = tableState.result.columns
          this.tableState.filter = tableState.result.filter
          this.createData = createData.result
        }
      )
    },

    infiniteScrollRequest(request) {
      return apiTo.GET_PAGINATED_LICENSES(request)
    },

    onGridReady(agGrid) {
      this.agGrid = agGrid
      this.tableState.filter && this.agGrid.api.setFilterModel(this.tableState.filter)
      this.tableState.columns && this.agGrid.columnApi.setColumnState(this.tableState.columns)
    },

    saveTableState() {
      const columns = this.agGrid.columnApi.getColumnState()
      const filter = this.agGrid.api.getFilterModel()

      apiTo.MODIFY_LIST_VIEW_TABLE_STATE('licenses', { columns, filter })
    },

    exportToExcel() {
      this.mixinExportToExcel(this.$refs.agGrid.getGridOptions(), [], 'licenses')
    }
  }
}
</script>
